module.exports = __webpack_public_path__ + "static/media/realestate.d4215102.jpg";